<template>
  <!-- eslint-disable max-len -->
  <el-dialog
    title="维修处理"
    :visible="visible"
    @close="onClose"
    @open="onOpen"
    width="60%"
    top="5%"
    :close-on-click-modal="false"
  >
    <!-- 仅维修类型是产品以及更换方式是更换配件才能操作 -->
    <el-table
      :data="itemList"
      style="margin-bottom: 10px"
      v-if="item.Type === 0 && item.ReplacementMode === 1"
    >
      <el-table-column prop="NameNumber" label="配件型号名称" />
      <el-table-column prop="OriginalSN" label="原配件SN" width="180" />
      <el-table-column prop="NewSN" label="新配件SN" width="180" />
      <el-table-column label="质保开始日期" width="100">
        <template slot-scope="scope">
          <div v-if="scope.row.QualityStartAt">
            {{ $sys.dateFormat(scope.row.QualityStartAt, "Y-m-d") }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="质保结束日期" width="100">
        <template slot-scope="scope">
          <div v-if="scope.row.QualityEndAt">
            {{ $sys.dateFormat(scope.row.QualityEndAt, "Y-m-d") }}
          </div>
        </template>
      </el-table-column>
      <el-table-column width="60" label="更换">
        <template slot-scope="scope">
          <el-button
            type="primary"
            @click.stop="onChangeClick(scope.row)"
            title="更换"
          >
            <i class="fas fa-exchange-alt"></i>
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-form
      :model="mainItem"
      ref="itemform"
      label-width="120px"
      :rules="rules"
    >
      <el-form-item label=" 补充说明" prop="SupplementaryDesc">
        <el-input
          v-model="mainItem.SupplementaryDesc"
          :autosize="{ minRows: 3 }"
          type="textarea"
          placeholder="请输入补充说明"
        ></el-input>
      </el-form-item>
    </el-form>

    <div slot="footer">
      <el-button @click="onClose">
        <i class="fas fa-times"></i> 取 消
      </el-button>
      <el-button type="primary" @click="onSubmit" :disabled="submitting">
        <i class="far fa-save"></i> 提 交
      </el-button>
    </div>

    <el-dialog
      title="选择配件"
      :visible.sync="accvisible"
      append-to-body
      :close-on-click-modal="false"
      @close="accvisible = false"
      width="30%"
    >
      <el-form
        ref="accItemForm"
        label-width="120px"
        :model="accItem"
        :rules="accRules"
      >
        <el-form-item label="配件SN" prop="TaID">
          <select2
            labelName="SN"
            v-model="accItem.TaID"
            url="dci/product/stock-canuse-acc-list"
            :clearable="true"
            placeholder="选择配件SN"
            no-data-text="没有配件SN"
            style="width: 100%"
            :urlParams="{
              where: {},
            }"
            q="SN:like"
            :qinwhere="true"
            :queryOne="false"
          ></select2>
        </el-form-item>
        <el-form-item label="质保开始日期" prop="QualityStartAt">
          <el-date-picker
            v-model="accItem.QualityStartAt"
            style="width: 100%"
            type="date"
            placeholder="请选择日期"
            @change="changeDate"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="质保结束日期" prop="QualityEndAt">
          <el-date-picker
            v-model="accItem.QualityEndAt"
            style="width: 100%"
            type="date"
            placeholder="请选择日期"
          ></el-date-picker>
        </el-form-item>
        <div style="text-align: right">
          <el-button type="text" @click="syncQualityDate"
            >同步产品质保日期</el-button
          >
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="accvisible = false">
          <i class="fas fa-fw fa-times" aria-hidden="true"></i> 取 消
        </el-button>
        <el-button type="primary" @click="onChangeConfim" :disabled="changing">
          <i class="far fa-fw fa-save" aria-hidden="true"></i> 确 定
        </el-button>
      </div>
    </el-dialog>
  </el-dialog>
</template>

<script>
export default {
  props: {
    value: Object,
    visible: Boolean,
  },
  data() {
    return {
      item: _.clone(this.value),
      mainItem: {
        ID: "",
        SupplementaryDesc: "",
      },
      rules: {
        // SupplementaryDesc: [
        //   { required: true, message: "补充说明不能为空", trigger: "blur" },
        // ],
      },
      submitting: false,
      itemList: [], //维修相关配件
      orItem: null, //原配件
      taItem: null, //新配件
      changing: false,
      accvisible: false,
      accItem: {
        //更换配件信息
        DciProductMaintainID: null,
        OrID: null,
        TaID: null,
        QualityStartAt: null,
        QualityEndAt: null,
      },
      accRules: {
        TaID: [{ required: true, message: "配件SN不能为空", trigger: "blur" }],
        QualityStartAt: [
          { required: true, message: "质保开始日期不能为空", trigger: "blur" },
        ],
        QualityEndAt: [
          { required: true, message: "质保结束日期不能为空", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    onOpen() {
      this.item = _.cloneDeep(this.value);
      this.mainItem.ID = this.item.ID;
      this.mainItem.SupplementaryDesc = "";
      this.getList();
    },
    onClose() {
      this.$emit("update:visible", false);
      this.itemList = [];
      this.item = {};
    },
    //获取产品维修相关配件列表
    getList() {
      this.$axios
        .get("dci/maintain/maintain-accessories", {
          params: {
            DciProductMaintainID: this.item.ID,
          },
        })
        .then((response) => {
          this.itemList = response.data;
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {});
    },

    onSubmit() {
      this.$refs.itemform.validate((valid) => {
        if (!valid) {
          return;
        }
        this.submitting = true;
        const itemData = {
          ...this.mainItem,
        };
        this.$axios
          .request({
            url: "dci/maintain/maintain",
            method: "post",
            data: itemData,
          })
          .then(() => {
            this.$message.success("提交成功");
            this.submitting = false;
            this.$emit("form:saved", true);
            this.$emit("update:visible", false);
            this.$emit("cancel");
          })
          .catch(({ response }) => {
            this.$sys.alarmResponse(response);
            this.submitting = false;
          });
      });
    },
    changeDate(val) {
      //质保开始日期修改，质保结束日期也自动修改,默认质保开始日期开始一年
      if (val) {
        const date = this.accItem.QualityStartAt;
        this.accItem.QualityEndAt = new Date(
          date.getTime() + 3600 * 1000 * 24 * 365
        );
      } else {
        this.accItem.QualityEndAt = val;
      }
    },
    syncQualityDate() {
      if (this.item.DciProduct != null) {
        this.accItem.QualityStartAt = this.item.DciProduct.QualityStartAt; //默认产品质保日期
        this.accItem.QualityEndAt = this.item.DciProduct.QualityEndAt;
      }
    },
    //点击更换按钮
    onChangeClick(row) {
      this.orItem = row;
      this.accItem.DciProductMaintainID = this.item.ID;
      this.accItem.OrID = row.DciAccessoryID;
      this.accItem.TaID = null;
      if (this.item.DciProduct != null) {
        this.accItem.QualityStartAt = this.item.DciProduct.QualityStartAt; //默认产品质保日期
        this.accItem.QualityEndAt = this.item.DciProduct.QualityEndAt;
      }
      this.accvisible = true;
    },
    onChangeConfim() {
      this.$refs.accItemForm.validate((valid) => {
        if (!valid) {
          return;
        }
        this.changing = true;
        //先判断是不是不同型号
        this.$axios
          .get(`dci/accessory/${this.accItem.TaID}`)
          .then((response) => {
            this.taItem = response.data;

            //如果不是同型号，确认是否更换
            if (
              this.orItem.DciAccessoryModel != null &&
              this.taItem.DciAccessoryModel != null &&
              this.orItem.DciAccessoryModel.Number !=
                this.taItem.DciAccessoryModel.Number
            ) {
              this.$confirm("配件型号不一致，确定继续更换此配件？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
              })
                .then(() => {
                  this.onChange();
                })
                .catch(() => {
                  this.changing = false;
                });
            } else {
              this.onChange();
            }
          })
          .catch(({ response }) => {
            this.changing = false;
            this.$sys.alarmResponse(response);
          });
      });
    },
    onChange() {
      this.$axios
        .request({
          url: "dci/maintain/maintain-accessory-change",
          method: "post",
          data: this.accItem,
        })
        .then(() => {
          this.changing = false;
          this.accvisible = false;
          this.getList();
          this.$message.success("更换成功");
        })
        .catch(({ response }) => {
          this.changing = false;
          this.$sys.alarmResponse(response);
        });
    },
  },
};
</script>
